import { FormFieldsContainer } from '../../../Form'

import { DayIntro } from './DayIntro'
import { FollowUpsField } from './FollowUpsField'
import { TargetDayField } from './TargetDayField'

function CalendarRelieveDayModalFields({
  day,
  dayLoad,
  followUps,
  nextFreeDay,
}) {
  return (
    <FormFieldsContainer>
      <DayIntro day={day} dayLoad={dayLoad} />
      <FollowUpsField dayLoad={dayLoad} followUps={followUps} />
      <TargetDayField day={day} nextFreeDay={nextFreeDay} />
    </FormFieldsContainer>
  )
}

export default CalendarRelieveDayModalFields
